import { createContext, useContext } from 'react';

export interface OnboardingContextType {
  currentStep: number;
  totalSteps: number;
  isSubmitting: boolean;
  isFirstStep: boolean;
  isLastStep: boolean;
  handleNext: () => void;
  handleBack: () => void;
  handleSkip?: () => void;
  canSkip: boolean;
  registerSubmitHandler: (handler: () => Promise<boolean>) => void;
  setIsSubmitting: (loading: boolean) => void;
  setTitle: (title: string, subtitle: string) => void;
  title: string;
  subtitle: string;
}

export const OnboardingContext = createContext<OnboardingContextType | null>(
  null
);

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
};
